module.exports = __webpack_public_path__ + "static/media/bhlogo.8cd05005.webp";